import { render, staticRenderFns } from "./moduleTemplateDetail.vue?vue&type=template&id=12821b8a&"
import script from "./moduleTemplateDetail.vue?vue&type=script&lang=ts&"
export * from "./moduleTemplateDetail.vue?vue&type=script&lang=ts&"
import style0 from "./moduleTemplateDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports